import toxi from 'toxiclibsjs';
import map from 'lodash/map';
import * as Vibrant from 'node-vibrant';

const blomIndex = Math.floor(Math.random() * 44 + 1);

const getRandomBlom = () => {
  return require(`../assets/blom/blom-a-generative-art-series-by-lucastswick-thumb-${blomIndex}.jpg`);
};

console.log('getRandomBlom ', blomIndex);

const generateColors = palette => {
  // console.log(palette);
  if (palette.Vibrant && palette.Vibrant.getHex() !== undefined) {
    const baseColor = palette.Vibrant.getHex();
    const color = toxi.color.TColor.newCSS(baseColor);
    color.setSaturation(0.5);
    let list = new toxi.color.theory.LeftSplitComplementaryStrategy().createListFromColor(
      color
    );
    list.sortByCriteria(toxi.color.AccessCriteria.HUE, true);
    list.sortByDistance(new toxi.color.HSVDistanceProxy(), true);
    // list.sortByDistance(false);
    let colors = map(list.colors, c => c.toRGBCSS());

    // list.sortByDistance(new toxi.color.HSVDistanceProxy());
    // const colors = map(list.colors, c => c.toRGBCSS());
    // const range = new toxi.color.ColorRange(list).addBrightnessRange(0, 1);
    const range = new toxi.color.ColorRange(list);
    const longList = range.getColors(40);
    // longList.sortByDistance(new toxi.color.HSVDistanceProxy());
    longList.sortByDistance(new toxi.color.HSVDistanceProxy());
    const ribbon = map(longList.colors, c => c.toRGBCSS());

    const marqueeColors = map(
      list.sortByDistance(new toxi.color.HSVDistanceProxy()).colors,
      c => c.toRGBCSS()
    );

    window.theme = { colors, ribbon, marqueeColors };

    // work[0].colorTheme.base = baseColor;
    // work[0].colorTheme.list = list;

    return { baseColor: baseColor, colors: colors, ribbon: ribbon };
  }

  return { baseColor: '#dd8800', colors: ['#121212', '#212121'] };
};

// const generateColors = () => {
//   let color = toxi.color.TColor.newRandom();
//   color.setSaturation(0.4);
//   color.setBrightness(0.4);
//   let list = new toxi.color.theory.TriadTheoryStrategy().createListFromColor(
//     color
//   );

//   list.sortByCriteria(toxi.color.AccessCriteria.HUE, true);
//   list.sortByDistance(new toxi.color.HSVDistanceProxy(), true);
//   let colors = map(list.colors, c => c.toRGBCSS());
//   const range = new toxi.color.ColorRange(list);
//   const longList = range.getColors(40);

//   longList.sortByDistance(new toxi.color.HSVDistanceProxy());
//   const ribbon = map(longList.colors, c => c.toRGBCSS());

//   const marqueeColors = map(list.sortByDistance(false).colors, c =>
//     c.toRGBCSS()
//   );

//   window.theme = { colors, ribbon, marqueeColors };

//   return { baseColor: color, colors: colors, ribbon: ribbon };
// };

const ThemeModel = {};

const randomBlom = getRandomBlom();

// ThemeModel.fetch = () => {
//   const colors = generateColors();
//   return new Promise(resolve => {
//     setTimeout(() => resolve({ ...colors, blomIndex }), 20);
//   });
// };

ThemeModel.fetch = () =>
  new Promise(resolve => {
    Vibrant.from(randomBlom)
      .getPalette()
      // .then(palette => new Promise(resolve => resolve(palette)));
      .then(palette =>
        resolve({
          ...generateColors(palette),
          blomIndex,
        })
      );
  });

// ThemeModel.fetch = () =>
//   new Promise(resolve => {
//     window.theme = {
//       colors: ['#121212', '#212121'],
//       ribbon: ['#121212', '#212121'],
//       marqueeColors: ['#121212', '#212121'],
//     };

//     setTimeout(() =>
//       resolve(
//         { baseColor: '#dd8800', colors: ['#121212', '#212121'], blomIndex: 1 },
//         100
//       )
//     );
//   });

// ThemeModel.fetchNew = () =>
//   Vibrant.from(getRandomBlom())
//     .getPalette()
//     .then(palette => resolve(palette));

export default ThemeModel;



// WEBPACK FOOTER //
// ./src/models/theme.js